export const VIDEO_HEIGHT = 360
export const VIDEO_WIDTH = 360
